import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazy-load';
import get from 'lodash.get';
import { ArrowCarousel, SwipeCarousel } from '../carousel';
import { isMobile, isTablet } from '../../utils/deviceTypeHelper';
import { ITEMS_PER_PAGE } from './recentlyViewedItemsHelpers.es';
import {
    trackInitialDisplay,
    trackArrowClick,
    trackItemClick,
    trackRecentItem,
} from './recentlyViewedItemsTrackingHelpers.es';
import styles from './RecentlyViewedItemsCarousel.scss';

const OFFSET_IMAGE_VERTICAL = 600;
const OFFSET_IMAGE_HORIZONTAL = 300;

class RecentlyViewedItemsCarousel extends Component {
    constructor(props) {
        super(props);

        this.initialyDisplayed = false;
        this.hasTrackingFired = {};

        this.handleContentVisible = this.handleContentVisible.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    handleItemClick({ item, index }) {
        trackItemClick();
        trackRecentItem({
            type: 'productClick',
            item,
            position: index + 1, // Tracking needs non zero index position.
        });
    }

    trackImpressions(page) {
        if (!this.hasTrackingFired[page]) {
            const { items } = this.props;
            const itemsPerPage = Math.floor(ITEMS_PER_PAGE);
            const startIndex = page * itemsPerPage;
            const visibleItems = items.slice(startIndex, startIndex + itemsPerPage);

            visibleItems.forEach((item, index) => {
                trackRecentItem({
                    type: 'productImpression',
                    item,
                    position: index + startIndex + 1, // Tracking needs non zero index position.
                });
            });

            this.hasTrackingFired[page] = true;
        }
    }

    handleContentVisible() {
        if (!this.initialyDisplayed) {
            const itemsReturned = this.props.items.length;

            trackInitialDisplay({ itemsReturned });
            this.trackImpressions(0);

            this.initialyDisplayed = true;
        }
    }

    handlePageChange(page) {
        /*
         * Needed for lazy images to load on swipe event.
         */
        this.forceUpdate();
        this.trackImpressions(page);
    }

    getCarouselItems() {
        const { items } = this.props;

        return items.map((item, index) => (
            <a
                key={`recent-${item.itemId}`}
                className={styles.itemLink}
                href={item.itemPdpUrl}
                onClick={() => this.handleItemClick({ item, index })}
            >
                <LazyLoad
                    offsetHorizontal={OFFSET_IMAGE_HORIZONTAL}
                    offsetVertical={OFFSET_IMAGE_VERTICAL}
                    onContentVisible={this.handleContentVisible}
                >
                    <img
                        className={styles.image}
                        src={get(item.itemImageUrl, 'src') || item.itemImageUrl}
                        alt={item.itemTitle}
                    />
                </LazyLoad>
            </a>
        ));
    }

    render() {
        const carouselProps = {
            itemsPerPage: ITEMS_PER_PAGE,
            children: this.getCarouselItems(),
            onPageChange: this.handlePageChange,
        };

        return isMobile() || isTablet() ? (
            <SwipeCarousel {...carouselProps} />
        ) : (
            <ArrowCarousel
                onLeftArrowClick={() => trackArrowClick({ direction: 'left' })}
                onRightArrowClick={() => trackArrowClick({ direction: 'right' })}
                {...carouselProps}
            />
        );
    }
}

RecentlyViewedItemsCarousel.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            contemporaryTrackingString: PropTypes.string,
            itemTitle: PropTypes.string.isRequired,
            itemId: PropTypes.string.isRequired,
            itemImageUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
            itemPdpUrl: PropTypes.string.isRequired,
            dealerPk: PropTypes.string.isRequired,
            category: PropTypes.string.isRequired,
        })
    ).isRequired,
};

export default RecentlyViewedItemsCarousel;



// WEBPACK FOOTER //
// ./assets/js/global/components/RecentlyViewedItems/RecentlyViewedItemsCarousel.jsx